
import { ServiceCategory } from '@/types/serviceTypes';

export const lawnGardenCategory: ServiceCategory = {
  id: 'lawn-maintenance',
  name: 'Lawn & Garden Care',
  icon: 'lawn',
  services: [
    {
      id: 'lawn-maintenance',
      title: 'Lawn Maintenance',
      description: 'Comprehensive lawn care services including mowing, edging, and treatments to keep your grass healthy and vibrant year-round.',
      features: [
        'Weekly mowing and edging',
        'Grass clipping removal',
        'Lawn aeration',
        'Overseeding services',
        'Detailed lawn analysis'
      ],
      image: 'https://images.unsplash.com/photo-1589923188900-85dae523342b?q=80&w=2070&auto=format&fit=crop'
    },
    {
      id: 'bed-maintenance',
      title: 'Bed Maintenance',
      description: 'Keep your garden beds looking pristine with our thorough maintenance services that enhance your landscape\'s overall appearance.',
      features: [
        'Weed removal and prevention',
        'Soil cultivation',
        'Edge redefinition',
        'Plant health monitoring',
        'Seasonal flower rotation'
      ],
      image: 'https://images.unsplash.com/photo-1591857177580-dc82b9ac4e1e?q=80&w=2071&auto=format&fit=crop'
    },
    {
      id: 'brush-removal',
      title: 'Brush Removal',
      description: 'Clear unwanted brush and overgrown areas to enhance safety, improve appearance, and create usable outdoor space.',
      features: [
        'Complete brush clearing',
        'Selective vegetation removal',
        'Stump grinding options',
        'Property line clearing',
        'Poison ivy/oak removal'
      ],
      image: 'https://images.unsplash.com/photo-1599768513835-fc37b8e4c564?q=80&w=2070&auto=format&fit=crop'
    },
    {
      id: 'spring-fall-cleanups',
      title: 'Spring/Fall Clean Ups',
      description: 'Prepare your property for the changing seasons with our thorough clean-up services that address seasonal debris and landscape needs.',
      features: [
        'Leaf removal and disposal',
        'Flower bed preparation',
        'Debris clearing',
        'Pre-winter preparations',
        'Post-winter recovery'
      ],
      image: 'https://images.unsplash.com/photo-1508197149814-0cc02e8b7f74?q=80&w=2069&auto=format&fit=crop'
    },
    {
      id: 'mulch-installation',
      title: 'Mulch Installation',
      description: 'Enhance your landscape with fresh mulch that improves soil health, reduces weeds, and adds a polished appearance to your property.',
      features: [
        'Premium mulch options',
        'Precise depth application',
        'Bed preparation',
        'Weed barrier installation',
        'Color and material selection'
      ],
      image: 'https://images.unsplash.com/photo-1629513621928-8888e1c806ed?q=80&w=2070&auto=format&fit=crop'
    },
    {
      id: 'fertilization',
      title: 'Fertilization',
      description: 'Custom fertilization programs designed to provide your lawn and plants with essential nutrients for optimal growth and health.',
      features: [
        'Soil testing and analysis',
        'Custom fertilizer blends',
        'Scheduled applications',
        'Organic options available',
        'Slow-release formulations'
      ],
      image: 'https://images.unsplash.com/photo-1615749188838-38161b5bf02e?q=80&w=2070&auto=format&fit=crop'
    },
    {
      id: 'pruning-weeding',
      title: 'Pruning/Weeding',
      description: 'Expert pruning and weeding services to maintain plant health, encourage growth, and preserve the beauty of your landscape.',
      features: [
        'Strategic plant pruning',
        'Shrub shaping and maintenance',
        'Hand weeding services',
        'Growth management',
        'Seasonal timing'
      ],
      image: 'https://images.unsplash.com/photo-1598902608379-11a423394495?q=80&w=2070&auto=format&fit=crop'
    }
  ]
};
